export default "__VITE_ASSET__ec04524f__"